
import XTable from 'vux/src/components/x-table/index.vue'

import { mapMutations } from 'vuex'
export default {
name: 'ClassificationcriteriaofrheumatoidarthritisbyXrays',
components: {
XTable
},
created () {
this.hideLoad()
},
methods: {
...mapMutations(['hideLoad'])
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/RI/ClassificationcriteriaofrheumatoidarthritisbyXrays.vue